import styled from 'styled-components';

import headerBackgroundImage from '../../../theme/assets/backgrounds/bg-4.webp';

export const StyledMainHeader = styled.div`
  width: 100%;
  z-index: 1;
  position: relative;

  .main-header {
    width: 100%;
    height: ${({ variant }) => (variant === 'small' ? '300px' : '480px')};

    &__bg {
      width: 100%;
      height: 100%;
      background-image: url(${headerBackgroundImage});
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  @media (max-width: 1050px) {
    .main-header {
      height: 160px;

      &__bg {
        background-position: bottom;
      }
    }
  }
`;
